export default __webpack_public_path__ + "326907c6cb37b74ff1c7c42d812848d9.png";